import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cartSlice";
import authReducer from './Auth/AuthSlice';
import OtpReducer from './Otp/otpSlice'
import userReducer from './User/userSlice'
import OrderReducer from './Order/orderSlice'
import favoriteReducer from "./FavouriteSlice/favouriteSlice"; // New favorites
import ProductsReducer from './Products/productSlice'
import db_cartsReducer from './db_Cart/db_cartSlice'
const store = configureStore({
  reducer: {
    cart: cartReducer,
    auth: authReducer,
    otp : OtpReducer,
    user : userReducer,
    order : OrderReducer,
    favorites: favoriteReducer,
    products : ProductsReducer,
    db_cart : db_cartsReducer

  },
});

export default store;
